import React from "react";
import { Typography } from "material-ui";
import RecordatorioImage from "./../../../images/recordatorio.svg";
import { formatDateTimeString } from "../../../utilities/datesFormatter";
import TileIcon from "./TileIcon";
import DoneIcon from "material-ui-icons/Done";
import DateIcon from "material-ui-icons/DateRange";
import TimeIcon from "material-ui-icons/AccessTime";

const fakeData = {
  Unidad: "TRA 01",
  FechaVencimiento: "2018-08-29T00:46:16",
  Estatus: "Vigente",
  Nombre: "Cambio aceite"
};

const ProximoRecoratorioTile = props => {
  const { data, lang } = props;
  const reminders = data.Recordatorios;
  const dateTime =
    reminders.length > 0 ? formatDateTimeString(reminders[0].DiaComienzo) : [];

  return (
    <div className="dashboard-tile">
      <TileIcon color="#f38a21" image={RecordatorioImage} />
      <div className="tile-header">{lang.ProximoRecordatorio}</div>
      {reminders.length > 0 && (
        <React.Fragment>
          <div className="tile-body">
            <div className="reminder-done">
              <DoneIcon />
            </div>
            <Typography variant="title" color="textSecondary" align="center">
              {reminders[0].Descripcion}
            </Typography>
          </div>
          <div className="tile-footer">
            <Typography variant="subheading" align="center" color="primary">
              {reminders[0].DescripcionUnidad}
            </Typography>
            <span className="reminder-date">
              <DateIcon /> {dateTime[0]}
            </span>
            <span className="reminder-date">
              <TimeIcon /> {dateTime[1]}
            </span>
          </div>
        </React.Fragment>
      )}

      {reminders.length == 0 && (
        <div className="tile-body">
          <Typography
            style={{ marginTop: "2rem" }}
            variant="display1"
            color="textSecondary"
            align="center"
          >
            {lang.SinDatosAMostrar}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default ProximoRecoratorioTile;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardTiles/ReminderTile.js